export enum NFTBgColors {
  BLUE = 'blue',
  NEON = 'neon',
  ORIGINAL = 'original'
}

export enum NFTHandColors {
  YELLOW = 'yellow',
  DARK = 'dark',
  TANNED = 'tanned',
  PALE = 'pale',
  PORCELAN = 'porcelan'
}

export interface NFTColors {
  background: NFTBgColors;
  hand: NFTHandColors;
}
